/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditcostshort2Inputs */

const en_creditcostshort2 = /** @type {(inputs: Creditcostshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not enough credits.`)
};

const de_creditcostshort2 = /** @type {(inputs: Creditcostshort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht genug Credits.`)
};

/**
* | output |
* | --- |
* | "Not enough credits." |
*
* @param {Creditcostshort2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcostshort2 = /** @type {((inputs?: Creditcostshort2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcostshort2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcostshort2(inputs)
	return de_creditcostshort2(inputs)
});
export { creditcostshort2 as "creditCostShort" }